export default __webpack_public_path__ + "static/media/123-soleils.15aa9042.webp";